<template>
    <div class="sidebar pe-4 pb-3">
        <nav class="navbar bg-light navbar-light">
            <!-- <router-link to="/" class="navbar-brand mx-4 mb-3">
                <h3 class="text-primary">{{ getsd.N }}</h3>
            </router-link> -->
            <!-- <pre>{{ getsd }}</pre> -->
            <div class="d-flex align-items-center ms-4 mb-4">
                <!-- <div class="position-relative">
                    <img class="rounded-circle" src="img/user.jpg" alt="" style="width: 40px; height: 40px;">
                    <div
                        class="bg-success rounded-circle border border-2 border-white position-absolute end-0 bottom-0 p-1">
                    </div>
                </div> -->
                <div class="ms-3">
                    <h6 class="mb-0">{{ getN }}</h6>
                    <span>{{ getstype }}</span>
                </div>
            </div>
            <div class="navbar-nav w-100">
                <router-link to="/" class="nav-item nav-link active"><i
                        class="fa fa-tachometer-alt me-2"></i>Dashboard</router-link>
                <div class="nav-item dropdown">
                    <a href="javascript:void(0);" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false"><i class="fas fa-users fa-fw me-2"></i>Manage</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link v-for="n in getusertyperange()" :key="n" class="dropdown-item"
                            :to="'/clients/' + n + '/0'"><i class="fas fa-users-cog fa-fw me-2"></i>&nbsp;{{
                                gettype(n) }}&nbsp;({{ gettypeshort(n) }})
                        </router-link>
                        <!-- <router-link to="/clientMt" class="dropdown-item"><i
                                class="fas fa-users-cog fa-fw me-2"></i>&nbsp;SST</router-link>
                        <router-link to="/scSSlist" class="dropdown-item"><i
                                class="fas fa-users-cog fa-fw me-2"></i>&nbsp;Stockists</router-link>
                        <router-link to="/scSalist" class="dropdown-item"><i
                                class="fas fa-users-cog fa-fw me-2"></i>&nbsp;Agent</router-link> -->
                    </div>
                </div>
                <router-link to="/liveGames" class="nav-item nav-link"><i
                        class="fas fa-hourglass-start fa-fw me-2"></i>Live Matches</router-link>
                <router-link to="/completedMatchesList" class="nav-item nav-link"><i
                        class="fas fa-hourglass-end fa-fw me-2"></i>Completed Matches</router-link>
                <router-link to="/blockSports" class="nav-item nav-link"><i class="bi bi-ban me-2"></i>&nbsp;Block
                    Market</router-link>
                <!-- <a class="nav-item nav-link"><i class="fa fa-chart-bar me-2" href="javascript:void(0);"></i>Manage Clients</a> -->
                <div class="nav-item dropdown">
                    <a href="javascript:void(0);" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false"><i class="bi bi-people-fill"></i>&nbsp;Manage Clients</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/clients/16/0" class="dropdown-item"><i
                                class="fas fa-users-cog fa-fw me-2"></i>&nbsp;My Clients</router-link>
                        <router-link to="/blockedUser" class="dropdown-item"><i
                                class="fas fa-users-cog fa-fw me-2"></i>&nbsp;Blocked Clients</router-link>
                        <router-link to="/commissionandLimit" class="dropdown-item"><i
                                class="fas fa-users-cog fa-fw me-2"></i>&nbsp;Commission & Limits</router-link>
                    </div>
                </div>
                <router-link to="/blockSports" class="nav-item nav-link"><i
                        class="fas fa-lock fa-fw me-2"></i>&nbsp;Manage Password</router-link>
                <router-link to="/blockSports" class="nav-item nav-link"><i
                        class="fas fa-language fa-fw me-2"></i>&nbsp;Language</router-link>
                <div class="nav-item dropdown">
                    <a href="javascript:void(0);" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false"><i class="fas fa-file-invoice fa-fw me-2"></i>&nbsp;Manage Ledgers</a>
                    <div class="dropdown-menu bg-transparent border-0">
                        <router-link to="/CollectionReport" class="dropdown-item"><i
                                class="fas fa-book fa-fw me-2"></i>&nbsp;Collection Report</router-link>
                        <router-link to="/ledgers" class="dropdown-item"><i
                                class="fas fa-book fa-fw me-2"></i>&nbsp;Company Ledgers</router-link>
                        <router-link to="/statementByUser" class="dropdown-item"><i
                                class="fas fa-chart-bar fa-fw me-2"></i>&nbsp;MY Statement</router-link>
                        <router-link to="/profitandloss" class="dropdown-item"><i
                                class="fas fa-rupee-sign fa-fw me-2"></i>&nbsp;Profit & Loss</router-link>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
import $$vm from "@/data/index";
export default {
    name: "Sidebar",
    computed: {
        getN: function () {
            return $$vm.bala.U;
        },
        getstype: function () {
            return $$vm.gettypeshort($$vm.bala.Ut);
        },
        gettype: function () {
            return function (n) {
                return $$vm.gettype(n);
            };
        },
        gettypeshort: function () {
            return function (n) {
                return $$vm.gettypeshort(n);
            };
        }
    },
    methods: {
        getusertyperange: function () {
            return $$vm.getusertyperange();
        },
    }
};
</script>
<style lang="">

</style>